import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import {
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

import { useAuth } from '../hooks/useAuth';
import { showToast } from '../utils/toast';

export default function LoginScreen() {
  const navigation = useNavigation();
  const { login, isLoading: loading } = useAuth();

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [isCodeLogin, setIsCodeLogin] = useState(true);

  const handleLogin = async () => {
    if (!phone || (isCodeLogin && !code)) {
      showToast('请填写完整信息', 'warning');
      return;
    }
    await login(phone, code);
  };

  const toggleLoginMethod = () => {
    setIsCodeLogin(!isCodeLogin);
    setCode('');
  };

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <View style={styles.content}>
        <View style={styles.logo}>
          <Text style={styles.logoText}>💬</Text>
        </View>
        <Text style={styles.title}>欢迎回来</Text>
        <Text style={styles.subtitle}>
          {isCodeLogin ? '请输入手机号和验证码' : '请输入手机号和密码'}
        </Text>

        <View style={styles.inputSection}>
          <TextInput
            style={styles.input}
            placeholder="手机号"
            value={phone}
            onChangeText={setPhone}
            keyboardType="phone-pad"
            maxLength={11}
            placeholderTextColor="#999"
          />
          <TextInput
            style={styles.input}
            placeholder={isCodeLogin ? '验证码' : '密码'}
            value={code}
            onChangeText={setCode}
            secureTextEntry={!isCodeLogin}
            maxLength={isCodeLogin ? 6 : 20}
            placeholderTextColor="#999"
          />
        </View>

        <TouchableOpacity
          style={[styles.loginButton, loading && styles.disabledButton]}
          onPress={handleLogin}
          disabled={loading}
        >
          {loading ? (
            <ActivityIndicator color="#fff" />
          ) : (
            <Text style={styles.loginButtonText}>登录</Text>
          )}
        </TouchableOpacity>

        <TouchableOpacity onPress={toggleLoginMethod}>
          <Text style={styles.toggleText}>{isCodeLogin ? '使用密码登录' : '使用验证码登录'}</Text>
        </TouchableOpacity>

        <TouchableOpacity onPress={() => navigation.navigate('Register' as any)}>
          <Text style={styles.registerText}>还没有账号？立即注册</Text>
        </TouchableOpacity>
      </View>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  disabledButton: {
    backgroundColor: '#ccc',
  },
  input: {
    backgroundColor: '#fff',
    borderRadius: 8,
    color: '#333',
    fontSize: 16,
    height: 50,
    marginBottom: 16,
    paddingHorizontal: 16,
  },
  inputSection: {
    marginBottom: 24,
  },
  loginButton: {
    alignItems: 'center',
    backgroundColor: '#c9a227',
    borderRadius: 8,
    height: 50,
    justifyContent: 'center',
    marginBottom: 16,
  },
  loginButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  logo: {
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: '#c9a227',
    borderRadius: 20,
    height: 80,
    justifyContent: 'center',
    marginBottom: 24,
    width: 80,
  },
  logoText: {
    fontSize: 40,
  },
  registerText: {
    color: '#666',
    fontSize: 14,
    textAlign: 'center',
  },
  subtitle: {
    color: '#999',
    fontSize: 14,
    marginBottom: 32,
    textAlign: 'center',
  },
  title: {
    color: '#333',
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
  },
  toggleText: {
    color: '#c9a227',
    fontSize: 14,
    marginBottom: 12,
    textAlign: 'center',
  },
});
